import React  from 'react';
import ReactEcharts  from 'echarts-for-react';
import i18n from '../../i18n';
// Chart option objects are built in plain helper functions and default
// parameters, where React hooks cannot be called — so translate through the
// i18n instance directly. Charts re-render when their page re-renders on a
// language change, so labels stay in sync.
const t = (key, opts) => i18n.t(key, opts);
const EchartComparison = (props)=>   {
    // Compute max from actual series data
    let dataMax = 0;
    if (props.series && props.series.length > 0) {
        props.series.forEach(s => {
            if (s.data) {
                s.data.forEach(v => {
                    const raw = (v !== null && typeof v === 'object') ? v.value : v;
                    const num = parseFloat(raw);
                    if (!isNaN(num) && num > dataMax) dataMax = num;
                });
            }
        });
    }
    // Round up to next 0.5 and add padding
    const computedMax = Math.ceil((dataMax * 1.1) * 2) / 2 || parseFloat(props.max);
    // Scale interval based on computed max
    let interval;
    if (computedMax <= 1) interval = 0.1;
    else if (computedMax <= 2) interval = 0.2;
    else if (computedMax <= 5) interval = 0.5;
    else interval = 1;

    let options =    {
        tooltip : {
            trigger: 'axis',
            formatter: function(params) {
                let result = params[0].axisValue + '<br/>';
                // Check if an Estimated Weight series has a value at this index
                const hasEstimated = params.some(p => p.seriesName.indexOf('Estimated Weight') !== -1 && p.value != null);
                params.forEach(p => {
                    const isActualSeries = p.seriesName.indexOf(t('charts:legend.actualWeight')) !== -1;
                    const isEstimatedSeries = p.seriesName.indexOf('Estimated Weight') !== -1;
                    if (isActualSeries && hasEstimated) {
                        result += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + p.color + ';"></span>' + p.seriesName + ': <span style="color:red;font-style:italic">' + t('charts:common.notEntered') + '</span><br/>';
                    } else if (isEstimatedSeries && p.value == null) {
                        // skip estimated line when no value
                    } else {
                        result += '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' + p.color + ';"></span>' + p.seriesName + ': ' + p.value + '<br/>';
                    }
                });
                return result;
            }
        },
        calculable : true,
        grid: {
            left: 40,
            top: 10,
            right: 35,
            bottom: 80
        },
        legend: {
            data: props.legends  // Names should match with the names provided in the series data
        },
        xAxis : [
            {
                type: 'category',
                boundaryGap:false,
                data:props.xaxis,
                splitLine: {
                    lineStyle: {
                        color: '#eee'
                    }
                },
                name: t('charts:common.days'),
                nameLocation: 'middle',
                nameGap: 30
            }
        ],
        yAxis : [
           {
            type: 'value',
            max: computedMax,
            boundaryGap: [0, '100%'],
            interval: interval,
            show: true,
            splitLine: {
                lineStyle: {
                    color: '#eee'
                }
            },
            name: t('charts:axis.birdWeightKg'),
            nameLocation: 'middle',
            nameGap: 28
           }
        ],
        
        series : props.series,
        dataZoom: [{
            type: 'slider',
            //startValue: '2018-08-15T10:14:13.914Z'
        }, {
           
            handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            handleSize: '80%'
            
        }],
    }

    return(
        <div className="Temp">
            {props.series.length>0 ?
            <ReactEcharts
                option={options}
                style={{ height: "400px", width: "100%" }}
                opts={{ renderer: "svg" }}
            /> : <div className="text-center">{t('charts:common.noDataFound')}</div>
            }
        </div>
    );
}
export default EchartComparison;